import { baseUniDriverFactory } from '../test-utils/utils/unidriver';

export const sidebarBackButtonDriverFactory = base => {
  return {
    ...baseUniDriverFactory(base),

    /** Click the button */
    clickButton: async () => base.click(),

    /** Get the button's text */
    getButtonText: async () => base.text(),
  };
};
